<template>
	<TheLayout>
		<div v-if="dataPermission && dataPermission.includes('NSH_INV_VIEW')">
			<div class="box-loading" v-if="loading">
				<div class="loading">
					<b-spinner class="m-2" variant="primary" role="status"></b-spinner>
				</div>
			</div>
			<titlePage class="mt-2" :title="title" :items="items" />
			<div class="row">
				<div class="col-lg-12">
					<div class="col-lg-12 p-0">
						<div class="card">
							<div class="card-body">
								<div class="d-flex justify-content-between mb-4">
									<div class="search-input">
										<el-input style="width:340px" placeholder="Tìm kiếm..." v-model="textSearch" clearable>
											<i slot="prefix" class="el-input__icon el-icon-search"></i>
										</el-input>
									</div>
								</div>
								<div v-for="(item, index) in listLocation" :key="index" class="mb-5">
									<div>
										<div class="d-fex align-items-center"><img class="mr-2" src="@assets/inventory-icons/store.png" /><b>Chi nhánh {{ item.name }}</b></div>
										<div class="groupCategory col-lg-12 px-0 mt-3">
											<b-table
												:items="item.arr"
												:fields="fieldsDisplay"
												:filter="textSearch"
												show-empty
												emptyFilteredText="Không tìm thấy kết quả phù hợp"
												emptyText="Vui lòng chuyển chi nhánh để xem kho">
												<template #cell(address)="data">
													{{ data.item.address }}
												</template>
												<template #cell(inventoryCode)="data">
													{{ data.item.inventoryCode }}
												</template>
												<template #cell(inventoryName)="data">
													{{ data.item.name }}
													<span v-if="data.item.isDefault == true" style="color: gray">(mặc định)</span>
												</template>
												<template #cell(inventoryDetail)="data">
													<span @click="getDeatail(data.item.coInventoryId)"
														v-if="dataPermission && dataPermission.includes('NSH_INV_ITEM_VIEW')"
														type="button"
														style="color: blue">Xem tồn kho
													</span>
												</template>
												<template #cell(action)="data"
													v-if="dataPermission && dataPermission.includes('NSH_INV_UPDATE')">
													<span class="btn-icon" @click="updateInventory(data.item)">
														<img class="mr-2" src="@assets/inventory-icons/pen.png" />
													</span>
												</template>
											</b-table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="box-loading" v-if="loading">
				<div class="loading">
					<b-spinner class="m-2" variant="primary" role="status"></b-spinner>
				</div>
			</div>
			<!--Modal cài đặt hiển thị-->
			<b-modal id="modal-scoped" v-model="settingModal">
				<template #modal-header="{}">
					<b>Cài đặt hiển thị</b>
				</template>
				<template #default="{}">
					<span>{{ draggingInfo }}</span>
					<b-form-group v-slot="{ ariaDescribedby }">
						<b-form-checkbox-group
							id="checkbox-group-2"
							v-model="selectedSetting"
							:aria-describedby="ariaDescribedby"
							name="flavour-2">
							<draggable
								:list="fieldsSelect"
								:disabled="!enabled"
								class="list-group"
								ghost-class="ghost"
								:move="checkMove"
								@start="dragging = true"
								@end="dragging = false">
								<div class="list-group-item"
									v-for="element in fieldsSelect"
									:key="element.label">
									<div class="display-beetwen">
										<div lg="11">
											<b-form-checkbox :value="element.label">{{ element.label }}</b-form-checkbox>
										</div>
										<div lg="1">
											<i class="fa-solid fa-bars" style="cursor: pointer; font-size: 20px"></i>
										</div>
									</div>
								</div>
							</draggable>
						</b-form-checkbox-group>
					</b-form-group>
				</template>

				<template #modal-footer="{ cancel }">
					<b-button size="sm" variant="primary-outline" @click="cancel()">Thoát</b-button>
					<b-button size="sm" variant="primary" @click="confirmSetting()">Hoàn tất</b-button>
				</template>
			</b-modal>
		</div>
		<NotPermission v-else></NotPermission>
		<!--Sửa thông tin kho-->
     

		<ValidationObserver ref="observerInventory" v-slot="{ validate }">
			<form @submit.stop.prevent="updateSelectedInventory(validate)">
				 <!-- popup -->
				 <el-dialog custom-class="n-modal" title="Thông tin kho" width="600px" :visible.sync="showUpdateModal">
        <!-- body -->
        <div>
					<div class="__modal-body-content">
						<div>
							<label>Mã kho <sup class="text-danger fz-12">*</sup></label>
							<BaseInput 
								placeholder="Nhập mã kho"
								:name="'Mã kho'"
								:rules="'required|lBetween:5,15|CHECK_HTML'"
								v-model="inventoryCode"
							/>
						</div>

						<div style="width: 70%">
							<label>Tên kho <sup class="text-danger fz-12">*</sup></label>
							<BaseInput
								placeholder="Nhập tên kho"
								:name="'Tên kho'"
								:rules="'required|lBetween:3,255|CHECK_HTML'"
								v-model="inventoryName"
							/>
						</div>
					</div>

					<div>
						<label>Địa chỉ <sup class="text-danger fz-12">*</sup></label>
						<BaseInput
							placeholder="Nhập địa chỉ"
							:name="'Địa chỉ'"
							:rules="'required|lBetween:3,255|CHECK_HTML'"
							v-model="inventoryAddress"
						/>
					</div>
				</div>
        <!-- footer -->
        <div slot="footer">
          <el-button class="n-btn" @click="showUpdateModal = false">Thoát</el-button>
          <el-button class="n-btn" type="primary" :disabled="inventoryName == '' || inventoryAddress == '' || inventoryCode == ''" @click="updateSelectedInventory(validate)">Hoàn tất</el-button>
        </div>
      </el-dialog>

				<!-- <BaseModal :show="showUpdateModal">
					<template #modal-header>
						<div class="d-flex justify-content-between">
							<h1>Thông tin kho</h1>
							<span class="cursor fz-20" @click="showUpdateModal = false">
								<i class="bx bx-x"></i>
							</span>
						</div>
					</template>
					<template #modal-body>
						<div class="__modal-body-content">
							<div>
								<label>Mã kho <sup class="text-danger fz-12">*</sup></label>
								<BaseInput 
									placeholder="Nhập mã kho"
									:name="'Mã kho'"
									:rules="'required|lBetween:5,15|CHECK_HTML'"
									v-model="inventoryCode"
								/>
							</div>

							<div style="width: 70%">
								<label>Tên kho <sup class="text-danger fz-12">*</sup></label>
								<BaseInput
									placeholder="Nhập tên kho"
									:name="'Tên kho'"
									:rules="'required|lBetween:3,255|CHECK_HTML'"
									v-model="inventoryName"
								/>
							</div>
						</div>

						<div>
							<label>Địa chỉ <sup class="text-danger fz-12">*</sup></label>
							<BaseInput
								placeholder="Nhập địa chỉ"
								:name="'Địa chỉ'"
								:rules="'required|lBetween:3,255|CHECK_HTML'"
								v-model="inventoryAddress"
							/>
						</div>
					</template>

					<template #modal-footer>
						<div class="d-flex justify-content-end">
							<BaseButton
							variant="outline"
							class="mr-2"
							@click="showUpdateModal = false">
								Thoát
							</BaseButton>
							<BaseButton
							type="submit"
							:disabled="inventoryName == '' || inventoryAddress == '' || inventoryCode == ''">
								Hoàn tất
							</BaseButton>
						</div>
					</template>
				</BaseModal> -->
			</form>
		</ValidationObserver>
	</TheLayout>
</template>
<script>

import { InventoryService } from "@/services/nextshop/inventory.service";
import titlePage from "@/components/title-page";
import Swal from "sweetalert2";
import VueCookies from "vue-cookies";
import getListLocation from "@/mixins/location/getListLocation";

export default {
	components: {
		titlePage,
	},
	mixins: [getListLocation],
	data() {
		return {
			dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
			coMerchantId: JSON.parse(localStorage.getItem("auth.currentMerchant")).id,
			roleUser: JSON.parse(localStorage.getItem("auth.currentUser")).role,
			listLocation: [],
			LID: VueCookies.get("LID"),
			title: "QUẢN LÝ KHO",
			items: [],
			loading: false,
			settingModal: false,
			fieldsInventory: [
				{ key: "inventoryCode", label: "Mã kho", thStyle: { width: "15%" } },
				{ key: "inventoryName", label: "Kho", thStyle: { width: "25%" } },
				{ key: "address", label: "Địa chỉ", thStyle: { width: "30%" } },
				{ key: "inventoryDetail", label: "Tồn kho", thStyle: { width: "11%" } },
				{ key: "action", label: "Thao tác", thStyle: { width: "10%" }, class: "text-center" },
			],
			fieldsDisplay: [],
			selectedSetting: [],
			enabled: true,
			dragging: false,
			showUpdateModal: false,
			inventoryCode: "",
			inventoryName: "",
			inventoryAddress: "",
			textSearch: "",
			inventoryCodeList: [],
			searchResult: [],
			searchList: [],
			searchField: []
		};
	},
	async created() {
		await this.checkConfigInventory()
		this.selectedSetting = this.fieldsInventory.map((field) => field.label);
		this.fieldsDisplay = this.fieldsInventory;
		this.fetchData()
	},
	computed: {
		colAction() {
			return this.fieldsInventory.filter((fil) => !fil.label);
		},
		fieldsSelect() {
			return this.fieldsInventory.filter((fil) => fil.label);
		},
		draggingInfo() {
			return this.dragging ? "" : "";
		},
	},
	methods: {
		getDeatail(storageId) {
			this.$router.push({ path: `/inventory-detail/${storageId}` });
		},
		confirmSetting() {
			const colSelect = [...this.fieldsSelect].filter((fil) =>
				this.selectedSetting.includes(fil.label)
			);
			this.fieldsDisplay = [...colSelect, ...this.colAction];
			this.settingModal = false;
		},
		checkMove: function (e) {
			window.console.log(e.draggedContext.futureIndex);
		},

		// list kho
		async fetchData() {
			try {
				this.loading = true;
				const params = {
					coMerchantId: this.coMerchantId,
					isOwner: this.roleUser == "employee" ? false : true,
					limit: 50,
					page: 1,
				};
				if (this.roleUser == "employee") {
					params.coLocationId = this.LID;
				}
				const data = await InventoryService.inventorylist(params);
				if (data.success) {
					this.inventoryCodeList = data.data.map((e) => e.inventoryCode);
					this.listLocation = await this.getListLocation()

					if (this.roleUser == "owner") {
						this.listLocation.map((el, index) => {
							this.listLocation[index].arr = [];
							data.data.map((e) => {
								if (e.coLocationId == el.coLocationId && e.isDefault == true) {
									this.listLocation[index].arr.push(e);
								}
							});
						});
					} else {
						this.listLocation = this.listLocation.filter(el => el.coLocationId === this.LID)
						this.listLocation[0].arr = []
						data.data.map((e) => {
							if (e.coLocationId == this.LID && e.isDefault == true) {
								this.listLocation[0].arr.push(e);
							}
						});
					}
				}
			} catch (error) {
				console.log(error);
			} finally {
				this.loading = false;
			}
		},

		async updateInventory(data) {
			this.showUpdateModal = true;
			this.inventoryCode = data.inventoryCode;
			this.inventoryName = data.name;
			this.inventoryAddress = data.address;
			this.coInventoryId = data.coInventoryId;
			this.description = data.description;
			this.status = data.status;
		},

		async updateSelectedInventory(validate) {
			validate().then(async (success) => {
				if (!success) {
					const el = document.querySelector(".is-invalid");
					el.focus();
					return;
				} else {
					this.showUpdateModal = false;
					const duplicate = this.inventoryCodeList.filter(
						(el) => el == this.inventoryCode
					);
					if (duplicate.length > 1) {
						Swal.fire({
							title: "Thất bại",
							text: "Mã kho hàng đã tồn tại",
							icon: "error",
							confirmButtonText: "Xác nhận",
						}).then(() => {
							this.showUpdateModal = true;
						});
					} else {
						const params = {
							address: this.inventoryAddress,
							coInventoryId: this.coInventoryId,
							description: this.description,
							inventoryCode: this.inventoryCode,
							lowItemQuantityThreshold: 0,
							name: this.inventoryName,
							status: this.status,
						};
						const response = await InventoryService.inventoryUpdate(
							params
						);
						if (response.success) {
							this.loading = false;
							Swal.fire({
								title: "Thành công",
								text: "Cập nhật thông tin kho thành công",
								icon: "success",
								confirmButtonText: "Xác nhận",
							}).then(() => {
								this.fetchData();
							});
						} else {
							this.loading = false;
							Swal.fire({
								title: "Mã kho đã tồn tại!",
								icon: "error",
								confirmButtonText: "Xác nhận",
							});
						}
					}
				}
			});
		},
	},
};
</script>
<style lang="scss">
.search-input input{
    height: 44px;
}
</style>

<style lang="scss" scoped>
#resp-table {
	width: 100%;
	display: table;
}
#resp-table-body {
	display: table-row-group;
}
.resp-table-row {
	display: table-row;
}
.table-body-cell {
	display: table-cell;
	border: 1px solid #dddddd;
	padding: 8px;
	line-height: 1.42857143;
	vertical-align: top;
}
.__modal-body-content {
	display: flex;
	flex-direction: row;

	& > div:first-child {
		width: 30%;
		padding-right: 10px;
		margin-bottom: 20px;
	}
}
</style>
